/* @flow */

import React from "react";
import { useLocation } from "react-router";
import styles from "./styles.scss";
import cn from "classnames";
import CartIcon from "icons/cart.svg";
import { QuoteData } from "data";
import { useData } from "crustate/react";
import { useTranslate } from "@awardit/react-use-translate";
import { ButtonLink } from "@crossroads/ui-components";

type Props = {
  className: string,
};

const CartCounter = ({ className = "" }: Props): React$Node => {
  const t = useTranslate();
  const location = useLocation();
  const data = useData(QuoteData);
  const onCheckout = location.pathname === t("URL.CHECKOUT_CART");
  const cartCount = data.data ? data.data.items.reduce((a, { qty }) => a + qty, 0) : 0;

  if (cartCount > 0) {
    return (
      <ButtonLink
        to={t("URL.CHECKOUT_CART")}
        aria-label={t("CART.NAV_BUTTON", { amount: cartCount })}
        className={cn(
          "link",
          styles.block,
          { [styles.active]: onCheckout },
          className
        )}
      >
        <CartIcon aria-label={t("ICONS.CART")} />
        <span className={cn(styles.count, { [styles.countSmall]: cartCount > 9 })}>
          {cartCount}
        </span>
      </ButtonLink>
    );
  }

  return (
    <div className={cn(styles.block, className)}>
      <CartIcon aria-label={t("ICONS.CART")} />
    </div>
  );
};

export default CartCounter;
